import { Badge, Button } from '@design-system';
import { TierCard } from './tier-card';

import { ChevronLeft, Sparkles } from 'lucide-react';

import { FREEMIUM_TIERS_IN_ORDER } from '@shared';

import type { FreemiumTier } from '@shared';

interface UsagePaywallProps {
  clientFirstName: string;
  onSelectTier: (tier: FreemiumTier, isLicensed: boolean) => void;
  onBack: () => void;
  isPending: boolean;
}

export function UsagePaywall({
  clientFirstName,
  onSelectTier,
  onBack,
  isPending,
}: UsagePaywallProps) {
  return (
    <div className="mx-auto w-full max-w-6xl">
      <div className="flex flex-col items-center gap-4 text-center">
        <Badge>
          <Sparkles />
          Pick how you want to plan
        </Badge>
        <h1 className="text-balance text-3xl font-bold text-gray-950">
          Explore Waterlily planning options
        </h1>
        <p className="text-foreground max-w-xl text-balance">
          Complete your plan on your own, with some help, or let us do it all. It&apos;s all we do.
        </p>
      </div>

      <div className="mt-12 grid items-stretch gap-6 md:grid-cols-3">
        {FREEMIUM_TIERS_IN_ORDER.map(config => (
          <TierCard
            key={config.tier}
            config={config}
            clientFirstName={clientFirstName}
            isPending={isPending}
            onSelect={() => onSelectTier(config.tier, config.isLicensed)}
          />
        ))}
      </div>

      <div className="mt-6">
        <Button
          variant="outline"
          onClick={onBack}
          disabled={isPending}
        >
          <ChevronLeft />
          Back to your goal
        </Button>
      </div>
    </div>
  );
}
